import { render, staticRenderFns } from "./AiManualDevice.vue?vue&type=template&id=4c389b13&scoped=true&"
import script from "./AiManualDevice.vue?vue&type=script&lang=js&"
export * from "./AiManualDevice.vue?vue&type=script&lang=js&"
import style0 from "./AiManualDevice.vue?vue&type=style&index=0&id=4c389b13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c389b13",
  null
  
)

export default component.exports